import { Link } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import { useEffect, useState } from "react";
import WebService from "../../Services/WebService";
import { googleApiTime, menus } from "../../Redux/action";
import { useDispatch } from "react-redux";

const VerticalMenu = () => {
  const [list, setList] = useState<any[]>([]);
  const [loader, setLoader] = useState(false);
  const [counts, setCounts] = useState<any>({}); // 👈 New state for counts
  const [setting, setSetting] = useState<any>({});

  const dispatch = useDispatch();

  useEffect(() => {
    getLeftMenuList();
    fetchCounts(); // initial fetch
    fetchSetting();

    const interval = setInterval(() => {
      fetchCounts();
    }, 120000); // every 2 minutes

    return () => clearInterval(interval); // cleanup
  }, []);

  const getLeftMenuList = () => {
    setLoader(true);
    WebService.getAPI({
      action: `left-menus`,
      body: null,
      isShowError: true,
    })
      .then((res: any) => {
        setList(res.list || []);
        dispatch(menus(res.list || []));
        setLoader(false);
      })
      .catch(() => {
        setLoader(false);
      });
  };

  const fetchCounts = () => {
    WebService.getAPI({
      action: `order-counts`, // 🔁 Replace with your real count API endpoint
      body: null,
      isShowError: false,
    })
      .then((res: any) => {
        setCounts(res); // res should contain fields like { order: 5, bazaar: 6, restaurant: 6 }
      })
      .catch(() => {});
  };

  const fetchSetting = () => {
    WebService.getAPI({
      action: `setting`, 
      body: null,
      isShowError: false,
    })
      .then((res: any) => {
        setSetting(res?.info || {}); 
        dispatch(googleApiTime(res?.info?.google_api_per_second || null));
      })
      .catch(() => {});
  };

  return (
    <div id="vertical_menu" className="verticle-menu">
      <div className="menu-list">
        <Accordion defaultActiveKey="0" className="collpade-menu">
          {(list || []).map((item: any, index: number) => {
            const hasChildren = item.child && item.child.length > 0;

            if (hasChildren) {
              return (
                <Accordion.Item eventKey={index.toString()} key={item.name}>
                  <Accordion.Header>
                    {item.name} {"  "}
                    {item.name === "Order" && (
                      <span className="count">{counts.bazaar + counts.restaurant + counts.service || 0}</span>
                    )}
                  </Accordion.Header>
                  <Accordion.Body>
                    {item.child.map((child: any) => (
                      <Link
                        key={child.name}
                        to={child.url}
                        className="menu-item ps-4"
                      >
                        <span className="nav-text">{child.name}</span>
                        {child.name === "Bazaar Orders" && (
                          <span className="count">{counts.bazaar || 0}</span>
                        )}
                        {child.name === "Restaurant Orders" && (
                          <span className="count">
                            {counts.restaurant || 0}
                          </span>
                        )}
                        {child.name === "Service Orders" && (
                          <span className="count">{counts.service || 0}</span>
                        )}
                      </Link>
                    ))}
                  </Accordion.Body>
                </Accordion.Item>
              );
            }

            return (
              <Link key={item.name} to={item.url} className="menu-item">
                {item.icon_class && <i className={`${item.icon_class}`} />}
                <span className="nav-text">{item.name}</span>{" "}
                {item.name === "Offers" && (
                  <span className="count">{counts.offer || 0}</span>
                )}

                {item.name === "Chat" && (
                  <span className="count">{counts.chat_count || 0}</span>
                )}
              </Link>
            );
          })}
        </Accordion>
      </div>
    </div>
  );
};

export default VerticalMenu;
